export default __webpack_public_path__ + "/dist/images/f&b-producer.44c4342a14721359531bee38698e1e04.png";